import React, {Component} from 'react';
import 'index.css';
import './CountDown.scss';
import moment from 'moment';
import * as countdown from 'countdown';
import {withTranslation} from 'react-i18next';
require('moment-countdown');

class CountDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: '',
      startedSent: false,
      liveStartedSent: false,
      startSoonSent: false,
      showChatSent: false,
    };
    this.tick = this.tick.bind(this);
    this.interval = 0;
  }
  componentDidMount() {
    this.interval = setInterval(this.tick, 500);
  }
  componentWillUnmount() {
    window.clearInterval(this.interval);
  }
  tick() {
    const {t, i18n} = this.props;
    switch (i18n.language) {
      case 'fr':
        countdown.setLabels(
          ' milliseconde| seconde| minute| heure| jour| semaine| mois| année| décennie| siècle| millénaire',
          ' millisecondes| secondes| minutes| heures| jours| semaines| mois| années| décennies| siècles| millénaires',
          ' et ',
          ', ',
          'maintenant',
        );
        break;
      default:
        countdown.resetLabels();
        break;
    }

    let started = moment().diff(this.props.startAt, 'seconds') > -6;
    let liveStarted = moment().diff(this.props.liveStartAt, 'seconds') > 0;
    let startSoon = moment().diff(this.props.startAt, 'seconds') > -15;
    let showChat = moment().diff(this.props.startAt, 'seconds') > -3600;
    if (started && !this.state.startedSent) {
      this.setState({startedSent: true}, () => window.setTimeout(this.props.onStart, 1000));
    }
    if (liveStarted && !this.state.liveStartedSent) {
      this.setState({liveStartedSent: true}, this.props.onLiveStart);
    }
    if (startSoon && !this.state.startSoonSent) {
      this.setState({startSoonSent: true}, this.props.onStartSoon);
    }
    if (showChat && !this.state.showChatSent) {
      this.setState({showChatSent: true}, this.props.onShowChat);
    }
    let countDown = '';
    if (!started) countDown = t('votre-seance-commence-dans') + ' ' + moment(this.props.startAt).countdown().toString();
    this.setState({
      msg: countDown,
      started: started,
    });
  }
  render() {
    return !this.state.started ? <span className="countdown">{this.state.msg}</span> : '';
  }
}
export default withTranslation()(CountDown);
